// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-dual-search-tables {
  display: grid;
}

.animated-dual-search-tables-panel {
  grid-area: 1/1;
  transition: opacity 200ms ease-out, transform 200ms ease-out, visibility 0ms linear 200ms;
}

.animated-dual-search-tables-primary {
  opacity: 0;
  pointer-events: none;
  transform: translateX(-10px);
  visibility: hidden;
}

.animated-dual-search-tables-secondary {
  opacity: 0;
  pointer-events: none;
  transform: translateX(10px);
  visibility: hidden;
}

.animated-dual-search-tables:not(.animated-dual-search-tables-show-works) .animated-dual-search-tables-primary {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
  transition-delay: 0ms, 0ms, 0ms;
  visibility: visible;
}

.animated-dual-search-tables-show-works .animated-dual-search-tables-secondary {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
  transition-delay: 0ms, 0ms, 0ms;
  visibility: visible;
}

@media (prefers-reduced-motion: reduce) {
  .animated-dual-search-tables-panel {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Search/SearchByParty/AnimatedDualSearchTables/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,yFACE;AAAJ;;AAKA;EACE,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,kBAAA;AAFF;;AAME;EACE,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,mBAAA;AAHJ;;AAQE;EACE,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,mBAAA;AALJ;;AASA;EACE;IACE,gBAAA;EANF;AACF","sourcesContent":[".animated-dual-search-tables {\n  display: grid;\n}\n\n.animated-dual-search-tables-panel {\n  grid-area: 1 / 1;\n  transition:\n    opacity 200ms ease-out,\n    transform 200ms ease-out,\n    visibility 0ms linear 200ms;\n}\n\n.animated-dual-search-tables-primary {\n  opacity: 0;\n  pointer-events: none;\n  transform: translateX(-10px);\n  visibility: hidden;\n}\n\n.animated-dual-search-tables-secondary {\n  opacity: 0;\n  pointer-events: none;\n  transform: translateX(10px);\n  visibility: hidden;\n}\n\n.animated-dual-search-tables:not(.animated-dual-search-tables-show-works) {\n  .animated-dual-search-tables-primary {\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateX(0);\n    transition-delay: 0ms, 0ms, 0ms;\n    visibility: visible;\n  }\n}\n\n.animated-dual-search-tables-show-works {\n  .animated-dual-search-tables-secondary {\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateX(0);\n    transition-delay: 0ms, 0ms, 0ms;\n    visibility: visible;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animated-dual-search-tables-panel {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
